"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconColors = exports.buttonColors = exports.FOCUS_BORDER_COLOR = void 0;
var FOCUS_BORDER_COLOR = exports.FOCUS_BORDER_COLOR = '#66BFFF';
var buttonColors = exports.buttonColors = {
  primary: {
    "default": {
      text: '#fff',
      border: '#0077CC',
      background: '#0077CC'
    },
    hover: {
      text: '#fff',
      border: '#005999',
      background: '#005999'
    },
    pressed: {
      text: '#fff',
      border: '#004A7F',
      background: '#004A7F'
    },
    active: {
      text: '#fff',
      border: '#004A7F',
      background: '#004A7F'
    },
    focus: {
      text: '#fff',
      border: FOCUS_BORDER_COLOR,
      background: '#0077CC'
    },
    outlined: {
      text: '#0077CC',
      border: '#0077CC',
      background: '#fff'
    },
    ghost: {
      text: '#0077CC',
      border: 'transparent',
      background: 'transparent'
    }
  },
  success: {
    "default": {
      text: '#fff',
      border: '#28865E',
      background: '#28865E'
    },
    hover: {
      text: '#fff',
      border: '#206B4A',
      background: '#206B4A'
    },
    pressed: {
      text: '#fff',
      border: '#185037',
      background: '#185037'
    },
    active: {
      text: '#fff',
      border: '#185037',
      background: '#185037'
    },
    focus: {
      text: '#fff',
      border: FOCUS_BORDER_COLOR,
      background: '#28865E'
    },
    outlined: {
      text: '#28865E',
      border: '#28865E',
      background: '#fff'
    },
    ghost: {
      text: '#28865E',
      border: 'transparent',
      background: 'transparent'
    }
  },
  danger: {
    "default": {
      text: '#fff',
      border: '#DE2F1B',
      background: '#DE2F1B'
    },
    hover: {
      text: '#fff',
      border: '#C72918',
      background: '#C72918'
    },
    pressed: {
      text: '#fff',
      border: '#9B2012',
      background: '#9B2012'
    },
    active: {
      text: '#fff',
      border: '#9B2012',
      background: '#9B2012'
    },
    focus: {
      text: '#fff',
      border: FOCUS_BORDER_COLOR,
      background: '#DE2F1B'
    },
    outlined: {
      text: '#DE2F1B',
      border: '#DE2F1B',
      background: '#fff'
    },
    ghost: {
      text: '#DE2F1B',
      border: 'transparent',
      background: 'transparent'
    }
  },
  secondary: {
    "default": {
      text: '#fff',
      border: '#5C5C5C',
      background: '#5C5C5C'
    },
    hover: {
      text: '#fff',
      border: '#575c66',
      background: '#5c626d'
    },
    pressed: {
      text: '#fff',
      border: '#575c66',
      background: '#5c626d'
    },
    active: {
      text: '#fff',
      border: '#575c66',
      background: '#5c626d'
    },
    focus: {
      text: '#fff',
      border: FOCUS_BORDER_COLOR,
      background: '#5C5C5C'
    },
    outlined: {
      text: '#5C5C5C',
      border: '#5C5C5C',
      background: '#fff'
    },
    ghost: {
      text: '#5C5C5C',
      border: 'transparent',
      background: 'transparent'
    }
  },
  light: {
    "default": {
      text: '#33373D',
      border: '#DFE3EC',
      background: '#DFE3EC'
    },
    hover: {
      text: '#33373D',
      border: '#BEC5D3',
      background: '#BEC5D3'
    },
    pressed: {
      text: '#fff',
      border: '#DFE3EC',
      background: '#DFE3EC'
    },
    active: {
      text: '#fff',
      border: '#575D67',
      background: '#575D67'
    },
    focus: {
      text: '#33373D',
      border: FOCUS_BORDER_COLOR,
      background: '#DFE3EC'
    },
    outlined: {
      text: '#33373D',
      border: '#BEC5D3',
      background: '#fff'
    },
    ghost: {
      text: '#33373D',
      border: 'transparent',
      background: 'transparent'
    }
  },
  destructive: {
    //destructive is deprecated, should be replaced with danger variant
    "default": {
      text: '#fff',
      border: '#DE2F1B',
      background: '#DE2F1B'
    },
    hover: {
      text: '#fff',
      border: '#C72918',
      background: '#C72918'
    },
    active: {
      text: '#fff',
      border: '#9B2012',
      background: '#9B2012'
    },
    focus: {
      text: '#fff',
      border: FOCUS_BORDER_COLOR,
      background: '#DE2F1B'
    },
    outlined: {
      text: '#DE2F1B',
      border: '#DE2F1B',
      background: '#fff'
    }
  },
  outline: {
    //outline is deprecated, should be replaced with light variant
    "default": {
      text: '#33373D',
      border: '#BEC5D3',
      background: '#fff'
    },
    hover: {
      text: '#33373D',
      border: '#BEC5D3',
      background: '#F6F8FA'
    },
    active: {
      text: '#33373D',
      border: '#BEC5D3',
      background: '#BEC5D3'
    },
    focus: {
      text: '#33373D',
      border: FOCUS_BORDER_COLOR,
      background: '#fff'
    },
    disabled: {
      text: '#BEC5D3',
      border: '#DFE3EC',
      background: '#fff'
    }
  }
};
var iconColors = exports.iconColors = {
  primary: {
    "default": {
      text: '#fff',
      border: '#0095FF',
      background: '#0095FF'
    },
    hover: {
      text: '#fff',
      border: '#0077CC',
      background: '#0077CC'
    },
    active: {
      text: '#fff',
      border: '#005999',
      background: '#005999'
    },
    focus: {
      text: '#fff',
      border: '#002C4C',
      background: '#0095FF'
    },
    disabled: {
      text: '#fff',
      border: '#E5F4FF',
      background: '#E5F4FF'
    },
    outlined: {
      text: '#0095FF',
      border: '#0095FF',
      background: '#fff'
    }
  },
  destructive: {
    "default": {
      text: '#fff',
      border: '#DE2F1B',
      background: '#DE2F1B'
    },
    hover: {
      text: '#fff',
      border: '#C72918',
      background: '#C72918'
    },
    active: {
      text: '#fff',
      border: '#9B2012',
      background: '#9B2012'
    },
    focus: {
      text: '#fff',
      border: '#58120A',
      background: '#DE2F1B'
    },
    disabled: {
      text: '#fff',
      border: '#FBEAE8',
      background: '#FBEAE8'
    },
    outlined: {
      text: '#DE2F1B',
      border: '#DE2F1B',
      background: '#fff'
    }
  },
  light: {
    "default": {
      text: '#33373D',
      border: '#DFE3EC',
      background: '#DFE3EC'
    },
    hover: {
      text: '#33373D',
      border: '#BEC5D3',
      background: '#BEC5D3'
    },
    pressed: {
      text: '#fff',
      border: '#DFE3EC',
      background: '#DFE3EC'
    },
    active: {
      text: '#fff',
      border: '#575D67',
      background: '#575D67'
    },
    focus: {
      text: '#33373D',
      border: '#575D67',
      background: '#575D67'
    },
    outlined: {
      text: '#33373D',
      border: '#BEC5D3',
      background: '#fff'
    },
    ghost: {
      text: '#33373D',
      border: 'transparent',
      background: 'transparent'
    }
  },
  outline: {
    "default": {
      text: '#767676',
      border: '#DFE3EC',
      background: '#fff'
    },
    hover: {
      text: '#767676',
      border: '#BEC5D3',
      background: '#F0F2F6'
    },
    active: {
      text: '#767676',
      border: '#BEC5D3',
      background: '#BEC5D3'
    },
    focus: {
      text: '#767676',
      border: '#333333',
      background: '#fff'
    },
    disabled: {
      text: '#BEC5D3',
      border: '#DFE3EC',
      background: '#fff'
    }
  }
};